export default __webpack_public_path__ + "static/media/slide.fa636e69.gif";